import BasicImage from "@home/components/BasicImage";
import SvgIcon from "@home/components/SvgIcon";
import { getName } from "@home/utils/common";
import { dynamicString } from "@home/utils/dynamicString";
import classNames from "classnames";
import React from "react";
import GameDefault from '@/pages/home/assets/img/common/game-default.svg';
import mobileGameDefaultIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg';

export const getTop10MidianHeader = (
  name: string,
  style?: React.CSSProperties,
  genreName?: string,
) => (
  <div className="dbd-benchmark-competitor-table-top10-median-header">
    <div
      className={classNames('dbd-benchmark-competitor-table-top10-median-name')}
      style={style}
    >
      {name}
    </div>
    <div className="dbd-benchmark-competitor-table-top10-median-genre-name">
      {genreName}
    </div>
  </div>
);

export const getGameHeader = (name: string, img: string, isPc = true) => (
  <div className="dbd-benchmark-competitor-table-game-header">
    <div className="dbd-benchmark-competitor-table-game-header-img">
      <BasicImage src={img} alt="" errorSrc={isPc ? GameDefault : mobileGameDefaultIcon} />
    </div>
    <div className="dbd-benchmark-competitor-table-game-header-name">
      {name}
    </div>
  </div>
);

export const currentGameRender = (item: any, isEn: boolean) => {
  const { value, percentile } = item;
  const text = getName(
    isEn,
    'Outranking {{percentile}}%',
    '超越{{percentile}}%',
  );
  return (
    <div className="dbd-benchmark-competitor-table-current-game">
      <div className="dbd-benchmark-competitor-table-current-game-value">
        {value}
      </div>
      <div
        className={classNames(
          'dbd-benchmark-competitor-table-current-game-more-then',
          {
            'is-more-then-50': Number(percentile) >= 50,
            'is-en': isEn
          },
        )}
      >
        {value === '-' ? '-' : dynamicString(text, { percentile })}
        {Number(percentile) >= 50 && <i><SvgIcon type='zan' /></i>}
      </div>
      <div className="dbd-benchmark-competitor-table-current-game-percentile">
        <div className="dbd-benchmark-competitor-table-current-game-progress" style={{ width: `${percentile}%` }}></div>
      </div>
    </div>
  );
};

export const getMetricRender = (item: any) => {
  const { name = '' } = item;
  return (
    <div className="dbd-benchmark-competitor-table-metrics">
      <div>{name}</div>
      {name?.toLowerCase()?.includes('steam') && (
        <SvgIcon type="awesome-steam" />
      )}
    </div>
  );
};
